import axios from "axios"
import { I18n } from 'react-redux-i18n'

import {getUrlPrefix, getHeaders} from "../helpers/urlHelper"

export function setSubject(subject) {
  return {type: "UPDATE_APPOINTMENT_SET_SUBJECT", payload: subject}
}

export function setFromDate(fromDate) {
  return {type: "UPDATE_APPOINTMENT_SET_FROM_DATE", payload: fromDate}
}

export function setToDate(toDate) {
  return {type: "UPDATE_APPOINTMENT_SET_TO_DATE", payload: toDate}
}

export function setDescription(description){
  return {type: "UPDATE_APPOINTMENT_SET_DESCRIPTION", payload: description}
}

export function addNormalSubject(){
  return {type: "UPDATE_APPOINTMENT_ADD_NORMAL_SUBJECT"}
}
export function deleteNormalSubject(idx){
  return {type: "UPDATE_APPOINTMENT_DELETE_NORMAL_SUBJECT", payload: idx}
}
export function updateNormalSubject(idx, newSubject){
  return {type: "UPDATE_APPOINTMENT_UPDATE_NORMAL_SUBJECT", payload: {idx: idx, newSubject: newSubject}}
}

export function addPersonSubject(){
  return {type: "UPDATE_APPOINTMENT_ADD_PERSON_SUBJECT"}
}
export function deletePersonSubject(idx){
  return {type: "UPDATE_APPOINTMENT_DELETE_PERSON_SUBJECT", payload: idx}
}
export function updatePersonSubject(idx, newSubject){
  return {type: "UPDATE_APPOINTMENT_UPDATE_PERSON_SUBJECT", payload: {idx: idx, newSubject: newSubject}}
}

export function setColor(color){
  return {type: "UPDATE_APPOINTMENT_SET_COLOR", payload: color}
}

export function setPrivate(priv){
  return {type: "UPDATE_APPOINTMENT_SET_PRIVATE", payload: priv}
}

export function fetchAppointment(id){
  return function(dispatch) {
    fetchExistingAppointment(dispatch, id)
  }
}

export function updateAppointment(appointment){
  return function(dispatch) {
    axios.put(getUrlPrefix() + "/afspraak/" + appointment.id,
      {
        subject: appointment.subject,
        fromDate: appointment.fromDate.format('YYYYMMDD'),
        fromTime: appointment.fromDate.format('HH:mm'),
        toDate: appointment.toDate.format('YYYYMMDD'),
        toTime: appointment.toDate.format('HH:mm'),
        description: appointment.description,
        normalSubjects: appointment.normalSubjects,
        personSubjects: appointment.personSubjects,
        color: appointment.color,
        appointmentPrivate: appointment.appointmentPrivate
      },
      {
        headers: getHeaders()
      })
      .then((response) => {
          fetchExistingAppointment(dispatch, appointment.id)

          //Show success snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'success',
            message: I18n.t('editAppointment.update_appointment_updated'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 1600
          }})
      })
      .catch((err) => {
        if(err.response && err.response.status === 422) {

          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('editAppointment.fields_incorrect'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          }})

          dispatch({type: "UPDATE_APPOINTMENT_SET_ERRORS", payload: err.response.data})
        }else{
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('global.server_error'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 5000
          }})

        }
      })
  }
}

function fetchExistingAppointment(dispatch, id){
  dispatch({type: "UPDATE_FETCH_APPOINTMENT"})

  axios.get(getUrlPrefix() + "/afspraak/" + id,
    {
      headers: getHeaders()
    })
    .then((response) => {
      dispatch({type: "UPDATE_FETCH_APPOINTMENT_COMPLETE", payload: response.data.afspraak})

    })
    .catch((err) => {
      dispatch({type: "UPDATE_FETCH_APPOINTMENT_REJECTED"})

      // Show error snackbar
      dispatch({type: "SHOW_SNACKBAR", payload: {
        variant: 'error',
        message: I18n.t('global.server_error'),
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        duration: 5000
      }})
    })
}



// WEBPACK FOOTER //
// ./src/js/actions/updateAppointmentActions.js